import { render, staticRenderFns } from "./ProjectsNew.vue?vue&type=template&id=4f3bd6e2&scoped=true&"
import script from "./ProjectsNew.vue?vue&type=script&lang=js&"
export * from "./ProjectsNew.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProjectsNew.vue?vue&type=style&index=1&id=4f3bd6e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3bd6e2",
  null
  
)

component.options.__file = "ProjectsNew.vue"
export default component.exports